import { Action } from '__common/store/action';
import { safeOfType as ofType } from '__common/utils/safeOfType';
import { Store } from 'redux';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';

import { ObstructionsActionTypes } from '__editor/panelsEditor/components/obstructions/ObstructionsActionsConstants';
import { ADD_OBSTRUCTION_ACTION } from '__editor/panelsEditor/components/obstructions/ObstructionsActions';

import { isPanelCollideWithObstacles } from '../obstructions/obstructionsCollisions';
import { removePanelsWithNoSiblings } from '__editor/panelsEditor/components/panels/utils/panelsManagment';
import { REMOVE_PANELS } from '../panels/panelsActions';

export function filterOutPanelsCollidingWithObstruction(action$: Observable<any>, state$: Observable<appState>): Observable<any> {
  return action$.pipe(
    ofType(ObstructionsActionTypes.ADD_OBSTRUCTION),
    withLatestFrom(state$),
    map(([action, state]: [Action<ADD_OBSTRUCTION_ACTION>, appState]) => {
      const {
        panels: {
          panels: _panels,
        },
        background: { 
          bgXY,
          metersPerPixel,
          moveArrayMode,
          toggleBaysContainer,
        }, 
        settings: { 
          panelWidth, 
          panelHeight,
        },
        projectConfiguration: {
          productId,
        },
      } = state;
      const panels = (<panelInState[]>_panels);
      const { roofId } = action.payload;
      const panelsToKeep = panels.filter(panel => !isPanelCollideWithObstacles(panel, roofId, bgXY.x, bgXY.y, panelWidth, panelHeight, metersPerPixel));
      const panelsOnlyWithSiblings = removePanelsWithNoSiblings(panelsToKeep);
      const idsToKeep = panelsOnlyWithSiblings.map(panel => panel.id);
      const idsToRemove = panels.filter((panel) => !idsToKeep.includes(panel.id)).map((panel => panel.id));
      return REMOVE_PANELS(idsToRemove, moveArrayMode, toggleBaysContainer, productId);
    })
  );
}
